// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/finalize_reference_image.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ReferenceImage } from "./reference_image_pb";
import { file_vision_assets_v1_reference_image } from "./reference_image_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/finalize_reference_image.proto.
 */
export const file_vision_assets_v1_finalize_reference_image: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vYXNzZXRzL3YxL2ZpbmFsaXplX3JlZmVyZW5jZV9pbWFnZS5wcm90bxIXcHJvdG9zLnZpc2lvbi5hc3NldHMudjEiuAEKHUZpbmFsaXplUmVmZXJlbmNlSW1hZ2VSZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLkZpbmFsaXplUmVmZXJlbmNlSW1hZ2VSZXF1ZXN0LlBhcmFtcxIYChBjbGllbnRfdXBsb2FkX2lkGAIgASgJGi4KBlBhcmFtcxISCgpwcm9qZWN0X2lkGAEgASgJEhAKCGFzc2V0X2lkGAIgASgJIrYBCh5GaW5hbGl6ZVJlZmVyZW5jZUltYWdlUmVzcG9uc2USTgoGcmVzdWx0GAEgASgLMj4ucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuRmluYWxpemVSZWZlcmVuY2VJbWFnZVJlc3BvbnNlLlJlc3VsdBpECgZSZXN1bHQSOgoJcmVmZXJlbmNlGAEgASgLMicucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuUmVmZXJlbmNlSW1hZ2ViBnByb3RvMw", [file_vision_assets_v1_reference_image]);

/**
 * @generated from message protos.vision.assets.v1.FinalizeReferenceImageRequest
 */
export type FinalizeReferenceImageRequest = Message<"protos.vision.assets.v1.FinalizeReferenceImageRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.FinalizeReferenceImageRequest.Params params = 1;
   */
  params?: FinalizeReferenceImageRequest_Params | undefined;

  /**
   * @generated from field: string client_upload_id = 2;
   */
  clientUploadId: string;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeReferenceImageRequest.
 * Use `create(FinalizeReferenceImageRequestSchema)` to create a new message.
 */
export const FinalizeReferenceImageRequestSchema: GenMessage<FinalizeReferenceImageRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_reference_image, 0);

/**
 * @generated from message protos.vision.assets.v1.FinalizeReferenceImageRequest.Params
 */
export type FinalizeReferenceImageRequest_Params = Message<"protos.vision.assets.v1.FinalizeReferenceImageRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string asset_id = 2;
   */
  assetId: string;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeReferenceImageRequest.Params.
 * Use `create(FinalizeReferenceImageRequest_ParamsSchema)` to create a new message.
 */
export const FinalizeReferenceImageRequest_ParamsSchema: GenMessage<FinalizeReferenceImageRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_reference_image, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.FinalizeReferenceImageResponse
 */
export type FinalizeReferenceImageResponse = Message<"protos.vision.assets.v1.FinalizeReferenceImageResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.FinalizeReferenceImageResponse.Result result = 1;
   */
  result?: FinalizeReferenceImageResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeReferenceImageResponse.
 * Use `create(FinalizeReferenceImageResponseSchema)` to create a new message.
 */
export const FinalizeReferenceImageResponseSchema: GenMessage<FinalizeReferenceImageResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_reference_image, 1);

/**
 * @generated from message protos.vision.assets.v1.FinalizeReferenceImageResponse.Result
 */
export type FinalizeReferenceImageResponse_Result = Message<"protos.vision.assets.v1.FinalizeReferenceImageResponse.Result"> & {
  /**
   * @generated from field: protos.vision.assets.v1.ReferenceImage reference = 1;
   */
  reference?: ReferenceImage | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.FinalizeReferenceImageResponse.Result.
 * Use `create(FinalizeReferenceImageResponse_ResultSchema)` to create a new message.
 */
export const FinalizeReferenceImageResponse_ResultSchema: GenMessage<FinalizeReferenceImageResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_finalize_reference_image, 1, 0);

